// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"b21282d6","369":"ee97db16","618":"7d837a39","641":"6bcd3e9c","967":"84406c97"}[chunkId] + ".chunk.js";
};